module.exports = __webpack_public_path__ + "aa8b47588d6216b5e7b2feb9d82e5a36.jpg";